/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuleMap,
    RuleMapFromJSON,
    RuleMapFromJSONTyped,
    RuleMapToJSON,
    RulesetApprovalSettings,
    RulesetApprovalSettingsFromJSON,
    RulesetApprovalSettingsFromJSONTyped,
    RulesetApprovalSettingsToJSON,
} from './';

/**
 * Rules configuration specific to an environment.
 * @export
 * @interface Ruleset
 */
export interface Ruleset {
    /**
     * 
     * @type {number}
     * @memberof Ruleset
     */
    readonly id?: number;
    /**
     * Indicates if the rule is enabled or not in an environment.
     * @type {boolean}
     * @memberof Ruleset
     */
    enabled?: boolean;
    /**
     * The URN for the Ruleset
     * @type {string}
     * @memberof Ruleset
     */
    readonly urn: string;
    /**
     * Timestamp when the Ruleset was last updated
     * @type {Date}
     * @memberof Ruleset
     */
    readonly updated_time?: Date;
    /**
     * Whether this Ruleset is archived or not. The ruleset is archived if the Flag was archived.
     * @type {boolean}
     * @memberof Ruleset
     */
    readonly archived?: boolean;
    /**
     * Ordered array of rule keys for the set.
     * @type {Array<string>}
     * @memberof Ruleset
     */
    rule_priorities: Array<string>;
    /**
     * 
     * @type {RuleMap}
     * @memberof Ruleset
     */
    rules?: RuleMap;
    /**
     * User-facing Unique identifier of the Variation.
     * @type {string}
     * @memberof Ruleset
     */
    default_variation_key?: string;
    /**
     * User friendly identifer of the Variation.
     * @type {string}
     * @memberof Ruleset
     */
    readonly default_variation_name?: string;
    /**
     * A url to the variation that will be executed if no rule audience is served.
     * @type {string}
     * @memberof Ruleset
     */
    readonly fetch_default_variation_url?: string;
    /**
     * User-facing Unique identifier of the Flag.
     * @type {string}
     * @memberof Ruleset
     */
    flag_key: string;
    /**
     * A url to fetch the Flag used by this Ruleset.
     * @type {string}
     * @memberof Ruleset
     */
    readonly fetch_flag_url?: string;
    /**
     * Link to self
     * @type {string}
     * @memberof Ruleset
     */
    readonly url: string;
    /**
     * 
     * @type {string}
     * @memberof Ruleset
     */
    readonly update_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Ruleset
     */
    readonly enable_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Ruleset
     */
    readonly disable_url?: string;
    /**
     * Environment id.
     * @type {number}
     * @memberof Ruleset
     */
    environment_id?: number;
    /**
     * User-facing Environment identifier.
     * @type {string}
     * @memberof Ruleset
     */
    environment_key: string;
    /**
     * Environment name.
     * @type {string}
     * @memberof Ruleset
     */
    environment_name?: string;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof Ruleset
     */
    readonly revision?: number;
    /**
     * Granular permission role
     * @type {string}
     * @memberof Ruleset
     */
    readonly role?: string;
    /**
     * status of ruleset.
     * @type {string}
     * @memberof Ruleset
     */
    status?: RulesetStatusEnum;
    /**
     * 
     * @type {RulesetApprovalSettings}
     * @memberof Ruleset
     */
    approval_settings?: RulesetApprovalSettings;
}

export function RulesetFromJSON(json: any): Ruleset {
    return RulesetFromJSONTyped(json, false);
}

export function RulesetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ruleset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'urn': json['urn'],
        'updated_time': !exists(json, 'updated_time') ? undefined : (new Date(json['updated_time'])),
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'rule_priorities': json['rule_priorities'],
        'rules': !exists(json, 'rules') ? undefined : RuleMapFromJSON(json['rules']),
        'default_variation_key': !exists(json, 'default_variation_key') ? undefined : json['default_variation_key'],
        'default_variation_name': !exists(json, 'default_variation_name') ? undefined : json['default_variation_name'],
        'fetch_default_variation_url': !exists(json, 'fetch_default_variation_url') ? undefined : json['fetch_default_variation_url'],
        'flag_key': json['flag_key'],
        'fetch_flag_url': !exists(json, 'fetch_flag_url') ? undefined : json['fetch_flag_url'],
        'url': json['url'],
        'update_url': !exists(json, 'update_url') ? undefined : json['update_url'],
        'enable_url': !exists(json, 'enable_url') ? undefined : json['enable_url'],
        'disable_url': !exists(json, 'disable_url') ? undefined : json['disable_url'],
        'environment_id': !exists(json, 'environment_id') ? undefined : json['environment_id'],
        'environment_key': json['environment_key'],
        'environment_name': !exists(json, 'environment_name') ? undefined : json['environment_name'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'approval_settings': !exists(json, 'approval_settings') ? undefined : RulesetApprovalSettingsFromJSON(json['approval_settings']),
    };
}

export function RulesetToJSON(value?: Ruleset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'rule_priorities': value.rule_priorities,
        'rules': RuleMapToJSON(value.rules),
        'default_variation_key': value.default_variation_key,
        'flag_key': value.flag_key,
        'environment_id': value.environment_id,
        'environment_key': value.environment_key,
        'environment_name': value.environment_name,
        'status': value.status,
        'approval_settings': RulesetApprovalSettingsToJSON(value.approval_settings),
    };
}

/**
* @export
* @enum {string}
*/
export enum RulesetStatusEnum {
    Draft = 'draft',
    Running = 'running',
    Paused = 'paused'
}


